import { UntypedFormControl, ValidatorFn } from '@angular/forms';

import { INPUT_TYPE } from '../contants/Contribute';

export class CustomControl extends UntypedFormControl {
  auxControl: UntypedFormControl;
  validations: CustomValidation[];
  label: string;
  placeholder: string;
  helperText: string;
  maxLength: number;
  max: number;
  loading: boolean;
  visible: boolean;
  helperData: any;
  type: INPUT_TYPE;

  constructor(controlData: CustomControlData) {
    const validatorsFnOrValidatorsName: any[] = controlData.validation?.map((validationPair) => validationPair[0]);
    const validators: ValidatorFn[] = (validatorsFnOrValidatorsName?.filter((validator) => typeof validator !== 'string') as ValidatorFn[]) || [];
    super(controlData.value, validators);
    if (controlData.hasAuxControl) this.auxControl = new UntypedFormControl();
    this.validations = controlData.validation?.map((validationPair) => new CustomValidation(validationPair)) || [];
    this.label = controlData.label;
    this.placeholder = controlData.placeholder;
    this.helperText = controlData.helperText;
    this.maxLength = controlData.maxLength;
    this.max = controlData.max;
    this.loading = controlData.loading;
    this.visible = controlData.visible;
    this.helperData = controlData.helperData || {};
    this.type = controlData.type;
  }
}

export type ValidationInfo = [ValidatorFn | string, string];

export class CustomValidation {
  error: string;
  message: string;

  constructor(validationPair: ValidationInfo) {
    this.error = typeof validationPair[0] === 'string' ? validationPair[0] : validationPair[0].name;
    this.message = validationPair[1];
  }
}

export interface CustomControlData {
  value?: any;
  validation?: ValidationInfo[];
  label?: string;
  placeholder?: string;
  helperText?: string;
  helperData?: any;
  maxLength?: number;
  max?: number;
  loading?: boolean;
  hasAuxControl?: boolean;
  visible?: boolean;
  type?: INPUT_TYPE;
}

export function getFunctionWithName(functionObj: ValidatorFn, functionName: string): ValidatorFn {
  return Object.defineProperty(functionObj, 'name', { value: functionName, writable: false });
}
